// Inject print styles into the document head (outside shadow DOM)
export function injectGlobalPrintStyles(): void {
  const styleId = 'terms-of-use-print-styles';

  // Check if styles already injected
  if (document.getElementById(styleId)) {
    return;
  }

  const styleElement = document.createElement('style');
  styleElement.id = styleId;
  styleElement.textContent = `
    @media print {
      header,
      footer,
      .ebds-tabs__navigation,
      .ebds-version-footer,
      .print-button {
        display: none !important;
      }

      .ebds-toast {
        display: none !important;
      }

      div.ebds>.ebds-container>.ebds-content>.dxf-container-fix>.ebds-container {
        display: none;
      }

      .ebds-tabs__panels>.ebds-tabs__panels__item {
        margin-top: 0 !important;
      }

      .ebds-tabs__panels>.ebds-tabs__panels__item>.ebds-tabs__panels__item__content>h2 {
        margin-top: 0;
      }
    }
  `;

  document.head.appendChild(styleElement);
}
